import { createSelector } from '@reduxjs/toolkit'

import { projectsApi } from 'client/store/projects/projectsApi'

export const getPhotoPointsByIds = (projectName: string, ids: Array<number>) => {
  return createSelector(projectsApi.endpoints.getPhotoPoints.select({ projectName }), (result) => {
    const features = result.data?.features ?? []
    if (features.length > 0) {
      return ids.map((id) => features[id])
    }
  })
}

export const ProjectsSelector = {
  getPhotoPointsByIds,
}
